module.exports = __webpack_public_path__ + "fonts/iconfont.35b48fb7.woff2";